/*
|--------------------------------------------------------------------------
| EMPLOYEE STATUS
|--------------------------------------------------------------------------
*/

export const EMPLOYEE_STATUSES = [
    "ACTIVE",
    "INACTIVE",
    "RESIGNED",
    "TERMINATED",
];


/*
|--------------------------------------------------------------------------
| EMPLOYMENT TYPES
|--------------------------------------------------------------------------
*/

export const EMPLOYMENT_TYPES = [
    "FULL_TIME",
    "PART_TIME",
    "CONTRACT",
    "INTERN",
    "FREELANCER",
];


/*
|--------------------------------------------------------------------------
| GENDER
|--------------------------------------------------------------------------
*/

export const GENDER_OPTIONS = [
    "MALE",
    "FEMALE",
    "OTHER",
];


/*
|--------------------------------------------------------------------------
| PERMISSION MODE
|--------------------------------------------------------------------------
*/

export const PERMISSION_MODES = {
    ROLE: "ROLE",
    CUSTOM: "CUSTOM",
};


/*
|--------------------------------------------------------------------------
| DEPARTMENTS
|--------------------------------------------------------------------------
|
| Used only as fallback.
| Backend dropdown remains source of truth.
|
|--------------------------------------------------------------------------
*/

export const DEFAULT_DEPARTMENTS = [
    "Administration",
    "Sales",
    "Purchase",
    "Inventory",
    "Accounts",
    "Repair & Service",
    "CCTV",
    "Networking",
    "Delivery",
    "Customer Support",
    "Website Management",
    "Marketing",
];


/*
|--------------------------------------------------------------------------
| DESIGNATIONS
|--------------------------------------------------------------------------
*/

export const DEFAULT_DESIGNATIONS = [
    "Administrator",
    "Store Manager",
    "Sales Executive",
    "Purchase Executive",
    "Inventory Executive",
    "Accountant",
    "Repair Technician",
    "CCTV Technician",
    "Network Engineer",
    "Delivery Executive",
    "Customer Support Executive",
    "Web Developer",
    "Marketing Executive",
];


/*
|--------------------------------------------------------------------------
| ATTENDANCE
|--------------------------------------------------------------------------
*/

export const ATTENDANCE_STATUSES = [
    "PRESENT",
    "ABSENT",
    "HALF_DAY",
    "PAID_LEAVE",
    "UNPAID_LEAVE",
    "HOLIDAY",
    "WEEK_OFF",
];


/*
|--------------------------------------------------------------------------
| ADVANCE
|--------------------------------------------------------------------------
*/

export const ADVANCE_RECOVERY_TYPES = [
    "MANUAL",
    "SALARY",
    "BOTH",
];


/*
|--------------------------------------------------------------------------
| SALARY PAYMENT
|--------------------------------------------------------------------------
*/

export const SALARY_PAYMENT_MODES = [
    "CASH",
    "BANK_TRANSFER",
    "UPI",
    "CHEQUE",
    "OTHER",
];


/*
|--------------------------------------------------------------------------
| LEAVE STATUS
|--------------------------------------------------------------------------
*/

export const LEAVE_STATUSES = [
    "PENDING",
    "APPROVED",
    "REJECTED",
    "CANCELLED",
];


/*
|--------------------------------------------------------------------------
| INITIAL EMPLOYEE FILTER
|--------------------------------------------------------------------------
*/

export const INITIAL_EMPLOYEE_FILTERS = {
    search: "",
    status: "ACTIVE",
    department: "",
    employmentType: "",
    roleId: "",
};


/*
|--------------------------------------------------------------------------
| INITIAL EMPLOYEE FORM
|--------------------------------------------------------------------------
*/

export const INITIAL_EMPLOYEE_FORM = {
    employeeCode: "",

    name: "",
    mobile: "",
    email: "",

    gender: "MALE",
    dateOfBirth: "",

    department: "",
    designation: "",

    employmentType: "FULL_TIME",
    joiningDate: "",

    status: "ACTIVE",

    basicSalary: "",
    allowances: "",
    deductions: "",

    addressLine: "",
    city: "",
    state: "",
    pincode: "",

    emergencyName: "",
    emergencyRelation: "",
    emergencyMobile: "",

    loginAccess: false,

    roleId: "",

    permissionMode: "ROLE",

    permissionIds: [],

    password: "",
};